import JSZip from "jszip";
import { saveAs } from "file-saver";

/** Serialize any in-DOM <svg> to a standalone SVG string (with xmlns). */
export function svgElementToString(svgEl) {
  const cloned = svgEl.cloneNode(true);
  if (!cloned.getAttribute("xmlns")) {
    cloned.setAttribute("xmlns", "http://www.w3.org/2000/svg");
  }
  if (!cloned.getAttribute("xmlns:xlink")) {
    cloned.setAttribute("xmlns:xlink", "http://www.w3.org/1999/xlink");
  }
  const serializer = new XMLSerializer();
  return '<?xml version="1.0" encoding="UTF-8"?>\n' + serializer.serializeToString(cloned);
}

export function downloadSVG(svgEl, filename) {
  const str = svgElementToString(svgEl);
  const blob = new Blob([str], { type: "image/svg+xml;charset=utf-8" });
  saveAs(blob, filename);
}

/** Rasterize SVG string to PNG at given width/height (transparent background). */
export function svgToPngBlob(svgString, outWidth, outHeight) {
  return new Promise((resolve, reject) => {
    const svgBlob = new Blob([svgString], { type: "image/svg+xml;charset=utf-8" });
    const url = URL.createObjectURL(svgBlob);
    const img = new Image();
    img.crossOrigin = "anonymous";
    img.onload = () => {
      const canvas = document.createElement("canvas");
      canvas.width = outWidth;
      canvas.height = outHeight;
      const ctx = canvas.getContext("2d");
      ctx.clearRect(0, 0, outWidth, outHeight);
      ctx.drawImage(img, 0, 0, outWidth, outHeight);
      URL.revokeObjectURL(url);
      canvas.toBlob((blob) => {
        if (!blob) reject(new Error("Canvas toBlob failed"));
        else resolve(blob);
      }, "image/png");
    };
    img.onerror = (e) => {
      URL.revokeObjectURL(url);
      reject(e);
    };
    img.src = url;
  });
}

export async function downloadPNG(svgEl, filename, width, height) {
  const str = svgElementToString(svgEl);
  const blob = await svgToPngBlob(str, width, height);
  saveAs(blob, filename);
}

/** Bulk export a list of { el, name, svg, png:[{w,h,suffix}] } into a zip. */
export async function downloadKit(items, zipName = "rona-wellness-brand-kit.zip") {
  const zip = new JSZip();
  for (const item of items) {
    const svgStr = svgElementToString(item.el);
    if (item.svg !== false) {
      zip.file(`svg/${item.name}.svg`, svgStr);
    }
    const sizes = item.png || [];
    for (const s of sizes) {
      try {
        const pngBlob = await svgToPngBlob(svgStr, s.w, s.h);
        const suffix = s.suffix || `${s.w}x${s.h}`;
        zip.file(`png/${item.name}-${suffix}.png`, pngBlob);
      } catch (e) {
        // skip this size but continue
        console.error("png fail", item.name, s, e);
      }
    }
  }
  const blob = await zip.generateAsync({ type: "blob" });
  saveAs(blob, zipName);
}
